import { DefaultState } from '@src/redux/types'

import { ST_INQUIRIES_PROOF_OF_STUDY_CREATE, ST_INQUIRIES_PROOF_OF_STUDY_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [ST_INQUIRIES_PROOF_OF_STUDY_LIST]: DefaultState<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'get'>
  [ST_INQUIRIES_PROOF_OF_STUDY_CREATE]: DefaultState<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'post'>
} = () => ({
  [ST_INQUIRIES_PROOF_OF_STUDY_LIST]: defaultState(),
  [ST_INQUIRIES_PROOF_OF_STUDY_CREATE]: defaultState(),
})
